import React, { useState } from 'react';
import Button from '~/components/atom/Button';
import StartLfaRequestModal from '../StartLfaRequestModal';
import JustificationContainer from '~/components/atom/JustificationContainer';
import isLfaApp from '~/util/isLFAApp';

type Props = {
  eventId: string;
  contactId: string;
  allowsLFACreation: boolean;
  onSuccess?: () => void;
};

const text = {
  startLfaRequest: 'Start LFA Request',
};

const StartLfaRequestButton: React.FC<Props> = ({
  eventId,
  contactId,
  allowsLFACreation,
  onSuccess,
}) => {
  const [showModal, setShowModal] = useState(false);

  // Don't show button if LFA creation is not allowed
  if (!allowsLFACreation || isLfaApp()) {
    return null;
  }

  return (
    <>
      {showModal && (
        <StartLfaRequestModal
          contactId={contactId}
          eventId={eventId}
          onClose={() => setShowModal(false)}
          onSuccess={onSuccess}
          hasOpenRequest={false}
        />
      )}
      <JustificationContainer margin={['s']}>
        <Button
          ghost
          size="small"
          label={text.startLfaRequest}
          onClick={() => setShowModal(true)}
          dataTestId="start-lfa-request-button"
        />
      </JustificationContainer>
    </>
  );
};

export default StartLfaRequestButton;
